export default {
  hordeEnergyToStr: '+{0} strength per current energy',
  hordeEnergyToEnergyReg: '+{0} energy regeneration per missing energy',
  hordeManaToHaste: '+{0} haste per current mana',
  hordeEnergyOnCrit: '+{0} energy on critical hit',
  hordeHealOnCrit: 'Heal {0} maximum health on critical hit',
  hordeRestoreCooldownOnCrit: 'Reduce cooldowns by {0} on critical hit',
  hordeBloodOnCrit: 'Gain {0} enemy blood on critical hit',
  hordeManaRest: 'Gain {1} mana regeneration after not using actives for {0}',
  hordeManasteal: 'Gain {0} mana on kill',
  hordePassiveRecovery: 'Apply {0} of recovery each second',
  hordeActiveDamageCrit: 'Damaging actives can crit at {0} efficiency',
  hordeActiveHealCrit: 'Healing actives can crit at {0} efficiency',
  hordeFirstStrikeStun: 'First strike also stuns for {0}',
  hordeSpellbladeOnActive: 'Combat actives trigger spellblade {0} more time(s)',
  hordeCritOnNonCrit: 'Gain +{0}* crit chance when your regular attacks do not crit. This effect can stack, but resets when you crit',
  hordeStunOnCrit: 'Crits have a 5% chance to stun for {0}',
  hordeReviveDivisionShield: 'Restore {0} of your division shield on revive',
  hordeReduceAttackOnAttack: 'Reduce enemy attack by {0} on regular attack, stacking up to {1} time(s)',
  hordeAttackAfterTime: 'Gain +{0} attack per minute in the same fight',
  hordeStrIntAfterTime: 'Gain {0} strength and intelligence per minute in the same fight',
  hordeFirstAttacksCrit: 'The first {0} attack(s) always crit',
  hordeFastKillBonusBlood: 'Gain +{0} blood if you kill the enemy in 5 seconds or less',
  hordeAttackPerMissingHealth: 'Gain +{0} attack per 1% missing health',
  hordeStrIntPerMissingHealth: 'Gain {0} strength and intelligence per 1% missing health',
  galleryBonusTier1Idea: '+{0} level(s) to all tier 1 ideas',
}
